import React, { Component, ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";

const variants = {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 },
};

const transition = {
    duration: 0.35,
    ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number],
};

interface PageTransitionProps {
    children: ReactNode;
    /** Optional key to trigger re-animation on route change */
    pageKey?: string;
}

/**
 * Wraps page content with a smooth fade-in + slide-up animation.
 * Can be used as a direct replacement for CSSTransitionComponent.
 */
export default class PageTransition extends Component<PageTransitionProps> {
    render() {
        const { children, pageKey } = this.props;
        return (
            <AnimatePresence mode="wait">
                <motion.div
                    key={pageKey}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    variants={variants}
                    transition={transition}
                >
                    {children}
                </motion.div>
            </AnimatePresence>
        );
    }
}
